import React, { useState, useEffect } from "react";
import { Table, Container, Row, Col, Pagination } from "react-bootstrap";
import { FaChevronDown, FaChevronUp, FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import Button, { BUTTON_TYPES } from '../../components/Button';
import SearchInput from '../../components/inputs/SearchInput';
import "../../styles/AdminPage.css";
import Page from "../../components/Page";
import FilterButton from "../../components/FilterButton";
import EditButton from "../../components/EditButton";
import EventCreateModal from "../../components/modals/EventCreateModal";
import EventEditModal from "../../components/modals/EventEditModal";
import QRCodeButton from "../../components/QRCodeButton";
import QRCodeModal from "../../components/modals/QRCodeModal";
import RescheduleModal from "../../components/modals/RescheduleModal";
import AttendanceModal from "../../components/modals/AttendanceModal";
import EventFilterModal from "../../components/modals/EventFilterModal";
import EventDeleteModal from "../../components/modals/EventDeleteModal";
import FilterTag from "../../components/FilterTag";
import { useLocation, useNavigate } from 'react-router-dom';
import { LocalDate, LocalDateTime } from '@js-joda/core';
import { useAdmin } from "./AdminContext";
import DuplicateButton from "../../components/DuplicateButton";
import EventArchiveModal from "../../components/modals/EventArchiveModal";
import { getAllEvents, getAllEventsIncludingArchived, restoreEvent } from "../../api/admin/AdminDashboardAPI";
import toast from "react-hot-toast";

export default function EventSearchPage() {
    const location = useLocation();
    const navigate = useNavigate();

    const { events, setEvents, committees, eventTypes, addEvent, updateEvents, removeEvent, semesters } = useAdmin();
    const [loading, setLoading] = useState(false);

    const [expandedRows, setExpandedRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortConfig, setSortConfig] = useState({ key: 'startDate', direction: 'descending' });
    const [searchQuery, setSearchQuery] = useState('');

    const [selectedEvent, setSelectedEvent] = useState(null);

    const [activeModal, setActiveModal] = useState(null);
    const [modalFormData, setModalFormData] = useState({});
    const [memberFilter, setMemberFilter] = useState(location.state?.selectedMember);
    const [appliedFilters, setAppliedFilters] = useState({});
    const [filterTags, setFilterTags] = useState([]);

    const itemsPerPage = 25;

    const clearLocationState = () => {
        navigate(location.pathname, { replace: true, state: {} });
    };

    const [isArchive, setIsArchive] = useState(false);


    let selectedMemberEventType = location.state?.selectedMemberEventType;

    useEffect(() => {
        setMemberFilter(location.state?.selectedMember);
    }, [location.state]);

    const openModal = (modalType) => {
        setActiveModal(modalType);
    };

    const closeModal = () => {
        setActiveModal(null);
    };

    const updateEventsWithRecurrence = () => {
        handleFilterApply(appliedFilters);
    }

    const recurrenceTypes = [
        { id: 1, recurrenceType: 'No Recurrence' },
        { id: 2, recurrenceType: 'Daily' },
        { id: 3, recurrenceType: 'Weekly' },
        { id: 5, recurrenceType: 'Monthly' },
    ];

    const handleFilterApply = async (data) => {
        setAppliedFilters(data);
        // TODO: start date and end date
        if (data.isArchiveEnabled || data.selectedSemesterTypeIDs) {
            try {
                setLoading(true);
                const fresh = await getAllEventsIncludingArchived({
                    isArchived: data.isArchiveEnabled,
                    semesters: data.selectedSemesterTypeIDs && data.selectedSemesterTypeIDs.length > 0 ? data.selectedSemesterTypeIDs : []
                });
                setEvents(fresh);
                search();
            } catch (err) {
                console.error("Failed to load events:", err);
            } finally {
                setLoading(false);
            }

        } else {

            try {
                setLoading(true);
                const fresh = await getAllEvents();
                setEvents(fresh);
                search();
            } catch (err) {
                console.error("Failed to load events:", err);
            } finally {
                setLoading(false);
            }

        }
        closeModal();
    };

    const defaultFilters = {
        selectedEventTypeIDs: [],
        selectedSemesterTypeIDs: [],
        selectedCommitteeTypeIDs: [],
        selectedRecurrenceTypeIDs: [],
        filterStartDate: "",
        filterEndDate: "",
        isArchiveEnabled: false,
    };


    useEffect(() => {
        setFilterTags([]);
        if (
            (appliedFilters.selectedEventTypeIDs &&
                appliedFilters.selectedEventTypeIDs.length > defaultFilters.selectedEventTypeIDs.length) || memberFilter
        ) {
            if (memberFilter) {
                if (typeof selectedMemberEventType === 'string') {
                    const matchedEventType = eventTypes.find(
                        evt => evt.eventType === selectedMemberEventType.slice(0, -1)
                    );


                    if (!Array.isArray(appliedFilters.selectedEventTypeIDs)) {
                        appliedFilters.selectedEventTypeIDs = [];
                    }

                    if (!appliedFilters.selectedEventTypeIDs.includes(matchedEventType.id)) {
                        setAppliedFilters(prevFilters => ({
                            ...prevFilters,
                            selectedEventTypeIDs: [...(prevFilters.selectedEventTypeIDs || []), matchedEventType.id],
                        }));
                    }

                    setFilterTags(prevTags => [...prevTags, {
                        field: 'attendedByMember',
                        id: 1,
                        label: `${selectedMemberEventType} Attended by ${memberFilter.firstName} ${memberFilter.lastName}`
                    }]);
                }
            } else {
                selectedMemberEventType = "";
            }
            if (appliedFilters.selectedEventTypeIDs) {
                if (typeof selectedMemberEventType === 'string') {
                    appliedFilters.selectedEventTypeIDs.forEach(id => {
                        const evt = eventTypes.find(et => et.id === id) || { id: id, eventType: "Incomplete Event" };
                        if (evt && evt.eventType != selectedMemberEventType.slice(0, -1)) {
                            setFilterTags(prevTags => [...prevTags, {
                                field: 'selectedEventTypeIDs',
                                id,
                                label: `Event Type: ${evt.eventType}`
                            }]);
                        }
                    });
                }
            }
        }

        if (
            appliedFilters.selectedSemesterTypeIDs &&
            appliedFilters.selectedSemesterTypeIDs.length > defaultFilters.selectedSemesterTypeIDs.length
        ) {
            appliedFilters.selectedSemesterTypeIDs.forEach(id => {
                const sem = semesters.find(st => st.id === id);
                if (sem) {
                    setFilterTags(prevTags => [...prevTags, {
                        field: 'selectedSemesterTypeIDs',
                        id,
                        label: `Semester: ${sem.semesterTitle}`
                    }]);
                }
            });
        }

        if (
            appliedFilters.isArchiveEnabled
        ) {
            setIsArchive(true);
            setFilterTags(prevTags => [...prevTags, {
                field: 'isArchiveEnabled',
                label: `Archived Events Included`
            }]);
        }

        if (
            appliedFilters.selectedCommitteeTypeIDs &&
            appliedFilters.selectedCommitteeTypeIDs.length > defaultFilters.selectedCommitteeTypeIDs.length
        ) {
            appliedFilters.selectedCommitteeTypeIDs.forEach(id => {
                if (id === 0) {
                    setFilterTags(prevTags => [...prevTags, {
                        field: 'selectedCommitteeTypeIDs',
                        id,
                        label: `Committee: None`
                    }]);
                } else {
                    const rec = committees.find(ct => ct.id === id);
                    if (rec) {
                        setFilterTags(prevTags => [...prevTags, {
                            field: 'selectedCommitteeTypeIDs',
                            id,
                            label: `Committee: ${rec.committeeName}`
                        }]);
                    }
                }
            });
        }

        if (
            appliedFilters.selectedRecurrenceTypeIDs &&
            appliedFilters.selectedRecurrenceTypeIDs.length > defaultFilters.selectedRecurrenceTypeIDs.length
        ) {
            appliedFilters.selectedRecurrenceTypeIDs.forEach(id => {
                const rec = recurrenceTypes.find(rt => rt.id === id);
                if (rec) {
                    setFilterTags(prevTags => [...prevTags, {
                        field: 'selectedRecurrenceTypeIDs',
                        id,
                        label: `Recurrence: ${rec.recurrenceType}`
                    }]);
                }
            });
        }

        if (appliedFilters.filterStartDate && appliedFilters.filterStartDate !== defaultFilters.filterStartDate) {
            const raw = appliedFilters.filterStartDate.trim();
            const [dateOnly, timePartWithZone] = raw.split('T');

            const [year, month, day] = dateOnly
                .split('-')
                .map(Number);

            const [hour, minute, second = 0] = timePartWithZone.split(':').map(Number);

            const localDate = new Date(year, month - 1, day, hour, minute, second);

            const formattedDate = localDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            }).replace(',', ' @');

            setFilterTags(prevTags => [...prevTags, {
                field: 'filterStartDate',
                label: `Start Date: ${formattedDate}`
            }]);
        }

        if (appliedFilters.filterEndDate && appliedFilters.filterEndDate !== defaultFilters.filterEndDate) {
            const raw = appliedFilters.filterEndDate.trim();
            const [dateOnly, timePartWithZone] = raw.split('T');

            const [year, month, day] = dateOnly
                .split('-')
                .map(Number);

            const [hour, minute, second = 0] = timePartWithZone.split(':').map(Number);

            const localDate = new Date(year, month - 1, day, hour, minute, second);

            const formattedDate = localDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            }).replace(',', ' @');

            setFilterTags(prevTags => [...prevTags, {
                field: 'filterEndDate',
                label: `End Date: ${formattedDate}`
            }]);
        }
    }, [appliedFilters]);

    const removeFilter = (field, id) => {
        switch (field) {
            case ('selectedEventTypeIDs'):
                setAppliedFilters(prev => ({
                    ...prev,
                    selectedEventTypeIDs: prev.selectedEventTypeIDs.filter(item => item !== id)
                }));

                setModalFormData(prev => ({
                    ...prev,
                    create: {
                        ...prev.create,
                        selectedEventTypeIDs: prev.create.selectedEventTypeIDs.filter(item => item !== id)
                    }
                }));
                break;
            case ('selectedSemesterTypeIDs'):
                const updatedSems = {
                    ...appliedFilters,
                    selectedSemesterTypeIDs: appliedFilters.selectedSemesterTypeIDs.filter(item => item !== id)
                };
                setAppliedFilters(updatedSems);
                setModalFormData(prev => ({
                    ...prev,
                    create: {
                        ...prev.create,
                        selectedSemesterTypeIDs: prev.create.selectedSemesterTypeIDs.filter(item => item !== id)
                    }
                }));

                handleFilterApply(updatedSems);

                break;
            case ('selectedCommitteeTypeIDs'):
                setAppliedFilters(prev => ({
                    ...prev,
                    selectedCommitteeTypeIDs: prev.selectedCommitteeTypeIDs.filter(item => item !== id)
                }));
                setModalFormData(prev => ({
                    ...prev,
                    create: {
                        ...prev.create,
                        selectedCommitteeTypeIDs: prev.create.selectedCommitteeTypeIDs.filter(item => item !== id)
                    }
                }));
                break;
            case ('selectedRecurrenceTypeIDs'):
                setAppliedFilters(prev => ({
                    ...prev,
                    selectedRecurrenceTypeIDs: prev.selectedRecurrenceTypeIDs.filter(item => item !== id)
                }));
                setModalFormData(prev => ({
                    ...prev,
                    create: {
                        ...prev.create,
                        selectedRecurrenceTypeIDs: prev.create.selectedRecurrenceTypeIDs.filter(item => item !== id)
                    }
                }));
                break;
            case ('filterStartDate'):
                setAppliedFilters(prev => ({ ...prev, filterStartDate: defaultFilters.filterStartDate }));
                setModalFormData(prev => ({
                    ...prev,
                    create: { ...prev.create, filterStartDate: defaultFilters.filterStartDate }
                }));
                break;
            case ('filterEndDate'):
                setAppliedFilters(prev => ({ ...prev, filterEndDate: defaultFilters.filterEndDate }));
                setModalFormData(prev => ({
                    ...prev,
                    create: { ...prev.create, filterEndDate: defaultFilters.filterEndDate }
                }));
                break;
            case ('attendedByMember'):
                if (memberFilter) {
                    if (typeof selectedMemberEventType === 'string') {
                        const matchedEventType = eventTypes.find(
                            evt => evt.eventType === selectedMemberEventType.slice(0, -1)
                        );
                        setMemberFilter(null);
                        clearLocationState();
                        setAppliedFilters(prev => ({
                            ...prev,
                            attendedByMember: null,
                            attendedByMemberEventType: null,
                            selectedEventTypeIDs: prev.selectedEventTypeIDs.filter(item => item !== matchedEventType.id)
                        }));
                        break;
                    }
                }
            case 'isArchiveEnabled':
                const updatedArchive = {
                    ...appliedFilters,
                    isArchiveEnabled: false
                };

                setAppliedFilters(updatedArchive);
                setIsArchive(false);
                setModalFormData(prev => ({
                    ...prev,
                    create: {
                        ...prev.create,
                        isArchiveEnabled: defaultFilters.isArchiveEnabled
                    }
                }));

                handleFilterApply(updatedArchive);
                break;
        }
    };

    

    useEffect(() => {
        const sortedEvents = orderRecent(events);
        const eventsWithPrimary = sortedEvents.map(event => ({
            ...event,
            primaryEventType: event.eventTypes[0].eventType,
            totalAttended: formatAttendance(event.membersAttended, event.visitorAttended),
        }));

        setDisplayEvents(eventsWithPrimary);
    }, [events]);

    const orderRecent = (toSort) => {
        let today = new Date();
        today.setDate(today.getDate() - 1); //new Date generates in UTC so, im just keeping everything from past 24 hours on top bc it would still be relevant
        today = today.toISOString();
            let nearestDate;
            let nearestID;
            let sortedData = [...toSort].sort((a, b) => {
                if(a['startDate'] >= today && (!nearestDate || a['startDate'] <= nearestDate)){
                    nearestDate = a['startDate'];
                    nearestID = a['id'];
                }
                if (a['startDate'] < b['startDate']) return -1;
                if (a['startDate'] > b['startDate']) return 1;
                return 0;
            });
            let before = [];
            let after = [];
            for(let i = 0; i < sortedData.length; i++){
                if(sortedData[i]['id'] == nearestID){
                    after = sortedData.slice(i);
                    break;
                }
                else{
                    before.push(sortedData[i]);
                }
            }
            return after.concat(before);
    }

    const [displayEvents, setDisplayEvents] = useState(orderRecent(events));

    const search = () => {
        const lowerSearchQuery = searchQuery.toLowerCase().trim();
        let filteredEvents;

        if (!lowerSearchQuery) {
            filteredEvents = [...events];
        } else {
            filteredEvents = events.filter(event =>
                event.eventName.toLowerCase().includes(lowerSearchQuery)
            );
        }

        if (filterTags && filterTags.length > 0) {
            filteredEvents = filteredEvents.filter(event => {
                // grouping filters by case
                const filtersByCase = filterTags.reduce((acc, filter) => {
                    if (!acc[filter.field]) {
                        acc[filter.field] = [];
                    }
                    acc[filter.field].push(filter);
                    return acc;
                }, {});

                // checking if event satisfies filters from all cases
                for (const caseName in filtersByCase) {
                    const caseFilters = filtersByCase[caseName];
                    const caseMatches = caseFilters.some(filter => {
                        switch (filter.field) {
                            case 'selectedEventTypeIDs': {
                                const expectedEventType = filter.label.split(': ')[1];
                                if (expectedEventType === "Incomplete Event") {
                                    return event.eventTypes.length === 0;
                                }
                                return event.eventTypes
                                    .some(etObj => etObj.eventType === expectedEventType);
                            }
                            case 'attendedByMember': {
                                if (typeof selectedMemberEventType === 'string' && memberFilter) {
                                    const expectedEventType = selectedMemberEventType.slice(0, -1);
                                    const expectedName = memberFilter.firstName + " " + memberFilter.lastName;
                                    return event.eventTypes
                                        .some(etObj => etObj.eventType === expectedEventType) &&
                                        event.membersAttended
                                            .some(member => (member.firstName + " " + member.lastName) === expectedName);
                                }
                                return false;
                            }
                            case 'filterStartDate': {
                                const labelDateTime = filter.label.split(': ')[1];
                                const [datePart, timePart] = labelDateTime.split(' @ ');
                                const [month, day, year] = datePart.split('/').map(Number);
                                const [time, meridiem] = timePart.split(' ');
                                let [hour, minute] = time.split(':').map(Number);
                                if (meridiem === 'PM' && hour < 12) hour += 12;
                                if (meridiem === 'AM' && hour === 12) hour = 0;
                                const expected = new Date(year, month - 1, day, hour, minute);
                                const actual = new Date(event.startDate);
                                return actual.getTime() >= expected.getTime();
                            }
                            case 'filterEndDate': {
                                const labelDateTime = filter.label.split(': ')[1];
                                const [datePart, timePart] = labelDateTime.split(' @ ');
                                const [month, day, year] = datePart.split('/').map(Number);
                                const [time, meridiem] = timePart.split(' ');
                                let [hour, minute] = time.split(':').map(Number);
                                if (meridiem === 'PM' && hour < 12) hour += 12;
                                if (meridiem === 'AM' && hour === 12) hour = 0;
                                const expected = new Date(year, month - 1, day, hour, minute);
                                const actual = new Date(event.endDate);
                                return actual.getTime() <= expected.getTime();
                            }
                            case 'selectedCommitteeTypeIDs': {
                                const expectedCommittee = filter.label.split(': ')[1];
                                if (expectedCommittee === 'None') {
                                    return !event.committee || event.committee.committeeName === "";
                                } else {
                                    return event.committee &&
                                        event.committee.committeeName === expectedCommittee;
                                }
                            }
                            case 'selectedSemesterTypeIDs': {
                                const expectedSemester = filter.label.split(': ')[1];
                                const semObj = semesters.find(s => s.semesterTitle === expectedSemester);
                                const eventStartDate = LocalDateTime.parse(event.startDate).toLocalDate();
                                const semStartDate = LocalDate.parse(semObj.startDate);
                                const semEndDate = LocalDate.parse(semObj.endDate);
                                return (eventStartDate.equals(semStartDate) || eventStartDate.isAfter(semStartDate))
                                    && (eventStartDate.equals(semEndDate) || eventStartDate.isBefore(semEndDate));
                            }
                            case 'selectedRecurrenceTypeIDs': {
                                const recurr = filter.label.split(': ')[1];
                                const recurrenceTypeStrings = recurrenceTypes.map(item => {
                                    if (item.recurrenceType === recurr) {
                                        return item.recurrenceType;
                                    } else {
                                        return null;
                                    }
                                });

                                const transformedRecurrenceTypes = recurrenceTypeStrings.map(type => {
                                    if (type === 'No Recurrence') {
                                        return null;
                                    } else if (type == null) {
                                        return;
                                    } else {
                                        return type.toUpperCase();
                                    }
                                });

                                return transformedRecurrenceTypes.includes(event?.recurrence?.frequency || null);

                            }
                            default:
                                return true; // If the filter doesn't have a specific case
                        }
                    });

                    // If for any case, none of the filters match, then the event should be excluded
                    if (!caseMatches) {
                        return false;
                    }
                }

                // If the event has passed the checks for all cases, include it
                return true;
            });
        }

        const sortedEvents = orderRecent(filteredEvents);

        const eventsWithPrimary = sortedEvents.map(event => ({
            ...event,
            primaryEventType: event.eventTypes[0].eventType,
            totalAttended: formatAttendance(event.membersAttended, event.visitorAttended),
        }));

        setDisplayEvents(eventsWithPrimary);
        setSortConfig({ key: 'startDate', direction: 'descending' });
        setCurrentPage(1);
        setExpandedRows([]);
    }

    const handleRowClick = (index) => {
        const isRowCurrentlyExpanded = expandedRows.includes(index);
        setExpandedRows(isRowCurrentlyExpanded
            ? expandedRows.filter(id => id !== index)
            : [...expandedRows, index]
        );
    };

    useEffect(() => {
        search();
    }, [filterTags]);

    const handleSearchChange = (e) => setSearchQuery(e.target.value);
    const handleSearchClick = (e) => {
        e.preventDefault();
        search();
    };

    const indexOfLastEvent = currentPage * itemsPerPage;
    const indexOfFirstEvent = indexOfLastEvent - itemsPerPage;
    const currentEvent = displayEvents.slice(indexOfFirstEvent, indexOfLastEvent);


    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        let sortedData;
        sortedData = [...displayEvents].sort((a, b) => {
            if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
            return 0;
        });
        setDisplayEvents(sortedData);
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return <FaSort />;
        return sortConfig.direction === 'ascending' ? <FaSortUp /> : <FaSortDown />;
    };

    const formatDate = (dateTime) => {
        var dt = LocalDateTime.parse(dateTime);
        return dt.monthValue() + "/" + dt.dayOfMonth() + "/" + dt.year();
    }

    const formatTime = (dateTime) => {
        let dt = LocalDateTime.parse(dateTime);
        let correctHour = dt.hour() % 12;
        if (correctHour === 0) {
            correctHour = 12;
        }

        let period = dt.hour() >= 12 ? "PM" : "AM"

        let min = dt.minute();
        let formattedMin = "";
        if (min < 10) {
            if (min === 0) {
                formattedMin += "00";
            } else {
                formattedMin += "0" + min
            }
        } else {
            formattedMin += min;
        }

        return correctHour + ":" + formattedMin + " " + period;
    }

    const formatAttendance = (membersAttended, visitorsAttended) => {
        if (membersAttended == null) {
            if (visitorsAttended == null) {
                return 0;
            }
            return visitorsAttended.length;
        } else {
            if (visitorsAttended == null) {
                return membersAttended.length;
            }
        }
        return membersAttended.length + visitorsAttended.length;
    }

    useEffect(() => {
        search();
    }, [appliedFilters, events]);

    const handleRestore = (eventArch) => {
        toast.loading("Restoring Event...");
        setTimeout(async () => {
            try {
                const response = await restoreEvent(eventArch);
                if (response.status === 200 || response.status === 201) {
                    toast.dismiss();
                    toast.success("Event restored!");
                    const updatedEvent = {
                        ...eventArch,
                        archived: false
                    }
                    updateEvents(updatedEvent);
                } else {
                    toast.dismiss();
                    toast.error("Event failed to restore. Status: " + response.status);
                }
            } catch (error) {
                toast.dismiss();
                console.error("Error restoring event:", error);
                toast.error("Something went wrong. Please check your connection and try again.");
            }
        }, 300);
    }
    const goToCommittee = (committee) => {
        navigate('/admin/committees', { state: { selectedCommittee: committee } });
    };

    return (
        <Page>
            <Container id="event-search-container" className="mt-3">
                <Row className="mb-3 align-items-center">
                    <Col>
                        <h2>Events</h2>
                    </Col>
                    <Col className="text-end">
                        <Button
                            id="create-event-button"
                            type={BUTTON_TYPES.primary}
                            buttonText="Create Event"
                            action={() => openModal('createEvent')}
                        />
                    </Col>
                </Row>

                <div className="d-flex flex-row mb-3 align-items-center w-100">
                    <form className="d-flex flex-row justify-content-between align-items-center flex-nowrap w-100" onSubmit={handleSearchClick} onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            search();
                        }
                    }}>
                        <div className="d-flex flex-row flex-nowrap flex-grow-1">
                            <SearchInput
                                id="search-bar"
                                placeholder="Search by Event Name"
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />

                            <FilterButton
                                id="filter-button"
                                type={BUTTON_TYPES.secondary}
                                action={(event) => {
                                    event.preventDefault();
                                    openModal('filterEvents');
                                }}
                            />
                        </div>

                        <div className="col-auto">
                            <Button
                                id="search-button"
                                type={BUTTON_TYPES.primary}
                                buttonText="Search"
                                action={(event) => {
                                    event.preventDefault();
                                    search()
                                }}
                            />
                        </div>
                    </form>
                </div>

                <div className="d-flex flex-row flex-wrap align-items-center mb-3" style={{ rowGap: '.5rem' }}>
                    <span className="me-3">Active Filters:</span>
                    {filterTags.map((tag, index) => (
                        <FilterTag
                            key={`${tag.field}-${tag.id || tag.label}`}
                            filterName={tag.label}
                            onRemove={() => removeFilter(tag.field, tag.id)}
                        />
                    ))}
                </div>

                {(loading) && (
                    <div>
                        Loading...
                    </div>
                )}

                {(!loading) && (
                <>
                
                <div>
                    <span className="text-start text-secondary mb-0">Total Events Found: {displayEvents.length}</span>
                </div>

                <Table striped bordered className="mt-0">
                    <thead>
                        <tr>
                            <th onClick={() => handleSort('eventName')}>
                                Event Name {getSortIcon('eventName')}
                            </th>
                            <th onClick={() => handleSort('primaryEventType')}>
                                Event Type(s) {getSortIcon('primaryEventType')}
                            </th>
                            <th onClick={() => handleSort('startDate')}> 
                                Event Date(s) {getSortIcon('startDate')}
                            </th>
                            <th onClick={() => handleSort('totalAttended')}>
                                Attendance {getSortIcon('totalAttended')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentEvent.map((event, index) => (
                            <React.Fragment key={index}>
                                <tr key={index} onClick={() => handleRowClick(index)}>
                                    <td>
                                        {event.eventName}
                                        {event.archived && <span className="archived-red">{" (Archived)"}</span>}
                                    </td>
                                    {/* TODO: make sure this doesn't go over certian size based on window width */}
                                    <td>{event.eventTypes.map(et => et.eventType).join(", ")}</td>
                                    <td>{formatDate(event.startDate)} - {formatDate(event.endDate)}</td>
                                    <td className="d-flex justify-content-between align-items-center">
                                        <span
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedEvent(event);
                                                openModal('attendance');
                                            }}
                                            className="text-link"
                                        >
                                            {formatAttendance(event.membersAttended, event.visitorAttended)}
                                        </span>
                                        <span className="expand-icon">
                                            {expandedRows.includes(index) ? <FaChevronUp /> : <FaChevronDown />}
                                        </span>
                                    </td>
                                </tr>
                                {expandedRows.includes(index) && (
                                    <tr key={`expanded-${index}`}>
                                        <td colSpan="4">
                                            <div className="d-flex flex-row justify-content mt-5 mb-3 ms-3">
                                                {formatDate(event.startDate) !== formatDate(event.endDate) && (
                                                    <>
                                                        <div className="col-3"><b>Start Date:</b> {formatDate(event.startDate)}</div>
                                                    </>
                                                )}
                                                {formatDate(event.startDate) === formatDate(event.endDate) && (
                                                    <>
                                                        <div className="col-3"><b>Date:</b> {formatDate(event.startDate)}</div>
                                                    </>
                                                )}
                                                <div className="col-3"><b>Location:</b> {event.location}</div>
                                                <div className="col-3"><b>Recurrence:</b> {event?.recurrence?.frequency || "No Recurrence"}</div>
                                                <div className="col-3"><b>Time:</b> {formatTime(event.startDate) + " - " + formatTime(event.endDate)}</div>

                                            </div>
                                            <div className="d-flex flex-row justify-content mt-5 mb-3 ms-3">
                                                {formatDate(event.startDate) !== formatDate(event.endDate) && (
                                                    <>
                                                        <div className="col-3"><b>End Date:</b> {formatDate(event.endDate)}</div>
                                                    </>
                                                )}
                                                {formatDate(event.startDate) === formatDate(event.endDate) && (
                                                    <>
                                                        <div className="col-3"></div>
                                                    </>
                                                )}
                                                <div className="col-3"><b>Committee:</b> {Object.values(event.committee)[1]}</div>
                                                <div className="col-3"><b>Committee Head(s):</b> {event.committee?.heads
                                                    ?.map(c => c.member?.firstName + " " + c.member?.lastName)
                                                    .join(", ")}</div>
                                            </div>
                                            <div className="d-flex flex-row justify-content-between">
                                                <div className="col-8">
                                                    <EditButton
                                                        id="edit-btn"
                                                        action={() => {
                                                            setSelectedEvent(event);
                                                            openModal('editEvent');
                                                        }}
                                                    />
                                                </div>
                                                <div className="d-flex flex-row col-auto justify-content-between align-items-center">
                                                    <div className="me-3">
                                                        <QRCodeButton
                                                            id="qr-code-button"
                                                            type={BUTTON_TYPES.primary}
                                                            action={() => {
                                                                setSelectedEvent(event);
                                                                openModal('qrcode');
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="me-3">
                                                        <DuplicateButton
                                                            id="edit-btn"
                                                            action={() => {
                                                                setSelectedEvent(event);
                                                                openModal('reschedule');
                                                            }}
                                                        />
                                                    </div>
                                                    {!event.archived && (
                                                        <Button
                                                            id="delete-button"
                                                            type={BUTTON_TYPES.danger}
                                                            buttonText={(formatAttendance(event.membersAttended, event.visitorAttended) > 0) 
                                                                || (LocalDateTime.now().isAfter(LocalDateTime.parse(event.endDate))) ? "Archive" : "Delete"}
                                                            action={() => {
                                                                setSelectedEvent(event);
                                                                openModal((formatAttendance(event.membersAttended, event.visitorAttended) > 0) 
                                                                || (LocalDateTime.now().isAfter(LocalDateTime.parse(event.endDate))) > 0 ? "archive" : "delete")
                                                            }}
                                                        />
                                                    )}
                                                    {event.archived && (
                                                        <Button
                                                            id="delete-button"
                                                            type={BUTTON_TYPES.success}
                                                            buttonText="Restore"
                                                            action={() => {
                                                                handleRestore(event);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </Table>
                

                <Pagination className="justify-content-center">
                    {Array.from({ length: Math.ceil(displayEvents.length / itemsPerPage) }, (_, i) => (
                        <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => {
                            setCurrentPage(i + 1);
                            setExpandedRows([]);
                        }}>
                            {i + 1}
                        </Pagination.Item>
                    ))}
                </Pagination>
                </>
                )}
            </Container>

            {activeModal === 'createEvent' && (
                <EventCreateModal
                    isOpen={true}
                    onClose={closeModal}
                    initialFormData={modalFormData.create || {}}
                    onFormDataChange={(data) =>
                        setModalFormData(prev => ({ ...prev, create: data }))
                    }
                    addNewEvent={(event) => {
                        addEvent(event);
                        modalFormData.create = {};
                    }}
                    eventTypes={eventTypes}
                />
            )}
            {activeModal === 'editEvent' && (
                <EventEditModal
                    isOpen={true}
                    onClose={closeModal}
                    event={selectedEvent}
                    eventId={selectedEvent.id}
                    initialFormData={modalFormData[selectedEvent.id] || {}}
                    onFormDataChange={(updatedValues) =>
                        setModalFormData((prev) => ({
                            ...prev,
                            [selectedEvent.id]: updatedValues
                        }))
                    }
                    eventTypes={eventTypes}
                    updateEvent={(displayEvents) => updateEvents(displayEvents)}
                    updateEventWithRecurrence={() => updateEventsWithRecurrence()}
                />
            )}
            {activeModal === 'delete' && (
                <EventDeleteModal
                    isOpen={true}
                    onClose={closeModal}
                    event={selectedEvent}
                    removeEvent={(event) => {
                        removeEvent(event);
                    }}
                    updateEventWithRecurrence={() => updateEventsWithRecurrence()}
                />
            )}
            {activeModal === 'archive' && (
                <EventArchiveModal
                    isOpen={true}
                    onClose={closeModal}
                    event={selectedEvent}
                    removeEvent={(event) => {
                        if (!isArchive) {
                            removeEvent(event);
                        } else {
                            updateEvents(event);
                            handleFilterApply(appliedFilters);
                        }
                    }}
                    updateEventWithRecurrence={() => updateEventsWithRecurrence()}
                />
            )}
            {activeModal === 'qrcode' && (
                <QRCodeModal
                    isOpen={true}
                    onClose={closeModal}
                    event={selectedEvent}
                />
            )}
            {activeModal === 'reschedule' && (
                <RescheduleModal
                    isOpen={true}
                    onClose={closeModal}
                    event={selectedEvent}
                    initialFormData={modalFormData[selectedEvent.id] || {}}
                    onFormDataChange={(updatedValues) =>
                        setModalFormData((prev) => ({
                            ...prev,
                            [selectedEvent.id]: updatedValues
                        }))
                    }
                    eventTypes={eventTypes}
                    addNewEvent={(event) => {
                        addEvent(event);
                        modalFormData.create = {};
                    }}
                    updateEventWithRecurrence={() => updateEventsWithRecurrence()}
                />
            )}
            {activeModal === 'attendance' && (
                <AttendanceModal
                    isOpen={true}
                    onClose={closeModal}
                    event={selectedEvent}
                />
            )}
            {activeModal === 'filterEvents' && (
                <EventFilterModal
                    isOpen={true}
                    onClose={closeModal}
                    initialFormData={{
                        ...modalFormData.create,
                        selectedSemesterTypeIDs: [semesters.find((semester) => {
                            const today = LocalDate.now();
                            const startDate = LocalDate.parse(semester.startDate);
                            const endDate = LocalDate.parse(semester.endDate);
                        
                            return !today.isBefore(startDate) && !today.isAfter(endDate);
                          }).id],
                        selectedEventTypeIDs: appliedFilters.selectedEventTypeIDs
                    }}
                    onFormDataChange={(data) =>
                        setModalFormData(prev => ({ ...prev, create: data }))
                    }
                    onApply={(data) => handleFilterApply(data)}
                    semesters={semesters}
                />
            )}
        </Page>
    );
}